import React from 'react';
import { FiAlertTriangle, FiHome, FiSearch, FiMail } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Error404 = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">


      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center px-4 py-12 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 text-center">
          <div className="flex justify-center">
            <div className="bg-red-100 p-4 rounded-full">
              <FiAlertTriangle className="h-12 w-12 text-red-600" />
            </div>
          </div>
          <h1 className="text-5xl font-extrabold text-gray-900">404</h1>
          <h2 className="mt-2 text-2xl font-medium text-gray-900">Page not found</h2>
          <p className="mt-2 text-gray-600">
            Sorry, we couldn't find the page you're looking for.
          </p>
          
          <div className="mt-8 space-y-4">
            <Link
              to="/"
              className="w-full flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <FiHome className="mr-2 h-5 w-5" />
              Return to homepage
            </Link>
            
            
            <Link
              to="/ContactPage"
              className="w-full flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-gray-700 bg-gray-50 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
            >
              <FiMail className="mr-2 h-5 w-5" />
              Contact support
            </Link>
          </div>
        </div>
      </main>

    </div>
  );
};

export default Error404;